(function () {
    'use strict';

    angular
        .module('webinar')
        .config(WebinarRoute);

    WebinarRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function WebinarRoute ($stateProvider) {
        $stateProvider
            .state('root.webinar', {
                abstract: true,
                url: '/webinar',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            })
            .state ('root.webinar.requests', {
                url: '/report/requests',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/webinar/reports/requests/reportFilter.html',
                        controller: 'WebinarRequestsController',
                        controllerAs: 'webinarRequests'
                    }
                }
            })
            .state ('root.webinar.blockDates', {
                url: '/report/blockdates',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/webinar/reports/blockdates/reportFilter.html',
                        controller: 'WebinarBlockDatesController',
                        controllerAs: 'webinarBlockDates'
                    }
                }
            });

    }
})();